import { type RefObject, createContext, createRef } from "react";

export type PrintAreaContextValue = {
	printAreaContentRef: RefObject<HTMLDivElement>;
	printContentArea?: () => void;
};

export const PrintAreaContext = createContext<PrintAreaContextValue>({
	printAreaContentRef: createRef(),
});
